const state = {
    isSharingExpense: false
};

const getters = {
    isSharingExpense: state => state.isSharingExpense
};

const mutations = {
    setIsSharingExpense(state, isShared = false) {
        state.isSharingExpense = isShared;
    }
};

const actions = {
    /**
     *
     * @param {Object} param
     * @param {Object} payload
     */
    async saveIsSharingExpense({ commit }, payload) {
        return new Promise(async (resolve, reject) => {
            try {
                const res = await axios.get(
                    `/api/v2/_modules/applications/${payload.application_id}`,
                    {
                        headers: {
                            Authorization: `Bearer ${payload.token}`
                        }
                    }
                );
                commit("setIsSharingExpense", res.data.is_shared_expense);

                // return resolve because it is promise
                resolve({ is_shared_expense: res.data.is_shared_expense });
            } catch (err) {
                console.error(err);
                // reject that ass
                reject(err);
            }
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
